import { mockAdapter } from "@/lib/api/adapters/mock";
import { httpAdapter } from "@/lib/api/adapters/http";
import { getApiConfig } from "@/lib/api/config";
import type { ApiAdapter } from "@/types/api-types";

let cachedAdapter: ApiAdapter | null = null;

export function getApiAdapter(): ApiAdapter {
  if (cachedAdapter) return cachedAdapter;

  const { useMock } = getApiConfig();
  cachedAdapter = useMock ? mockAdapter : httpAdapter;
  return cachedAdapter;
}

/** Reset cached adapter (useful in tests). */
export function resetApiAdapter(): void {
  cachedAdapter = null;
}
